'use strict'

module.exports = Backbone.Model.extend
  defaults:
    isOnPage: false

  parse: ({card, location}) ->
    id: @_getId(card, location)
    card: card
    cardId: card.id
    location: location
    isOnPage: @_getIsOnPage(card, location)
    bloodhoundDataString: @_getBloodhoundDataString(card)

  _getId: (card, location) ->
    "#{card.id}:#{location.lat}:#{location.lng}"

  _getBloodhoundDataString: (card, location) ->
    {accessType, permalink} = card
    isOnPage = @_getIsOnPage(card, location)

    JSON.stringify {accessType, isOnPage, permalink}

  _getIsOnPage: (card, location) ->
    # To be done in Pagination Client story
    true
